// extracted by mini-css-extract-plugin
export default {"container":"Example_container__q9P65","uiContainer":"Example_uiContainer__QemRg","code":"Example_code__92Bxl"};